var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEdit3 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 18.28,
  viewBox: "0 0 19 18.28",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.5 -2.22)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,20h9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5,3.5a2.121,2.121,0,1,1,3,3L7,19,3,20l1-4Z"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-3.8c80d22c.svg";
export { ForwardRef as ReactComponent };